export const NEXT_STEP = 'CHECKOUT::NEXT_STEP';

export function nextStep() {
    return {
        type: NEXT_STEP,
    };
}

export const PREVIOUS_STEP = 'CHECKOUT::PREVIOUS_STEP';

export function previousStep() {
    return {
        type: PREVIOUS_STEP,
    };
}

export const SET_STEP = 'CHECKOUT::SET_STEP';

export function setStep(step) {
    return {
        type: SET_STEP,
        step,
    };
}

export const SET_IS_ERROR_POPUP_VISIBLE = 'CHECKOUT::SET_IS_ERROR_POPUP_VISIBLE';

export function setIsErrorPopupVisible(isErrorPopupVisible) {
    return {
        type: SET_IS_ERROR_POPUP_VISIBLE,
        isErrorPopupVisible,
    };
}

export const SET_IS_LOADING = 'CHECKOUT::SET_IS_LOADING';

export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    };
}

export const SET_IS_PDF_GENERATING = 'CHECKOUT::SET_IS_PDF_GENERATING';

export function setIsPdfGenerating(isPdfGenerating) {
    return {
        type: SET_IS_PDF_GENERATING,
        isPdfGenerating,
    };
}

export const SET_PDF_URL = 'CHECKOUT::SET_PDF_URL';

export function setPdfUrl(pdfUrl) {
    return {
        type: SET_PDF_URL,
        pdfUrl,
    };
}

export const SET_CHECKOUT_BEHAVIOUR = 'CHECKOUT::SET_CHECKOUT_BEHAVIOUR';

export function setCheckoutBehaviour(behaviour) {
    return {
        type: SET_CHECKOUT_BEHAVIOUR,
        behaviour,
    };
}

export const SET_CHECKOUT_DEFAULTS = 'CHECKOUT::SET_CHECKOUT_DEFAULTS';

export function setCheckoutDefaults() {
    return {
        type: SET_CHECKOUT_DEFAULTS,
    };
}
